import { addDays } from 'date-fns';

export const CookieJar = {
  set: (name, value, expires = addDays(new Date(), 1)) => {
    const cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Strict;`;
    document.cookie = cookie;
  },
  get: (name) => {
    const cookies = document.cookie.split(';');

    const cookie = cookies.find((c) => {
      const cookieName = c.split('=')[0];
      return cookieName.trim() === name;
    });
    return cookie ? cookie.split('=')[1] : null;
  },
  remove: (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
};

export default CookieJar;
